module.exports = __webpack_public_path__ + "static/img/icon2-11.59c56bb8.png";